import service from "@/utils/request";

// 获取车队用户列表
export function getTeamUserList(params) {
  return service({
    url: "/fleet/user/invitation/query",
    method: "get",
    params: params,
    headers: {
      "portal-token": true
    }
  });
}

// 邮箱验证
export function validateEmail(params) {
  return service({
    url: "/fleet/user/invitation/email-check",
    method: "get",
    params: params,
    headers: {
      "portal-token": true
    }
  });
}

// 发送邀请
export function sendInvitation(params) {
  return service({
    url: "/fleet/user/invitation/send",
    method: "post",
    params: params.query,
    data: params.data,
    headers: {
      "portal-token": true
    }
  });
}

// 删除车队用户
export function deleteTeamUser(params) {
  return service({
    url: "/fleet/user/invitation/delete",
    method: "put",
    params: params,
    headers: {
      "portal-token": true
    }
  });
}

// 修改车队用户
export function editTeamUser(params) {
  return service({
    url: "/fleet/user/invitation/edit",
    method: "put",
    params: params
  })
}

export function createGroup(name) {
  return service({
    url: "/fleet/user/group/add",
    params: { name },
    headers: {
      "portal-token": true
    }
  });
}

export function removeGroup(groupId) {
  return service({
    url: "/fleet/user/group/delete",
    params: { groupId },
    headers: {
      "portal-token": true
    }
  });
}

export function getGroups() {
  return service({
    url: "/fleet/user/group/query",
    headers: {
      "portal-token": true
    }
  });
}

export function getGroup(groupId) {
  return service({
    url: "/fleet/user/group_member_query",
    params: { groupId },
    headers: {
      "portal-token": true
    }
  });
}

export function updateGroup(groupId, name) {
  return service({
    url: "/fleet/user/group/edit",
    params: { groupId, name },
    headers: {
      "portal-token": true
    }
  });
}

export function getMembers(data) {
  return service({
    params: data,
    url: "/fleet/user/company_Member_Query",
    headers: {
      "portal-token": true
    }
  });
}

export function addMembersToGroup({ groupId, userIds }) {
  return service({
    url: "/fleet/user/add_member_to_group",
    method: "post",
    params: { groupId },
    data: { idList: userIds },
    headers: {
      "portal-token": true
    }
  });
}

export function removeMemberFromGroup(params) {
  return service({
    url: "/fleet/user/delete_member_in_group",
    params,
    headers: {
      "portal-token": true
    }
  });
}

// 验证邮箱是否已经被注册
export function checkUserInfo(params) {
  return service({
    url: "/fleet/user/fleet_user/tp/info/get",
    method: 'post',
    data: params,
    headers: {
      "portal-token": true
    }
  });
}

